<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="task.id !== undefined"
          label="ID"
          v-model="task.id"
          disabled
        >
        </v-text-field>

        <v-datetime-picker
          label="Selecteaza data de start"
          v-model="task.startAt"
          @input="changeStartDate"
          :timePickerProps="timePickerProps"
        >
        </v-datetime-picker>

        <v-datetime-picker label="Select data de sfarsit" v-model="task.endAt">
        </v-datetime-picker>

        <v-text-field
          label="Titlu"
          v-model="task.title"
          :rules="requiredRule"
          required
        >
        </v-text-field>

        <v-select
          v-model="task.userId"
          :items="listUsers"
          prepend-icon="engineering"
          item-text="email"
          item-value="id"
          label="Tehnicianul asociat"
        ></v-select>

        <v-autocomplete
          v-model="task.clientId"
          :items="listClients"
          :search-input.sync="search"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          label="Client"
          placeholder="Cauta clientul"
          prepend-icon="supervisor_account"
          no-filter
        >
          <template v-slot:item="{ item }">
            <v-list-item-avatar
              color="indigo"
              class="text-h5 font-weight-light white--text"
            >
              {{ item.name.charAt(0) }}
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title :class="{
                'red--text': item.isSpecial,
                'font-weight-bold': item.isSpecial,
              }">{{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.addressDetails }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.isSpecial">Nota Speciala: {{ item.specialNotes }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <v-textarea label="Descriere" v-model="task.description"> </v-textarea>

        <v-text-field label="Nr. telefon" v-model="task.phone"> </v-text-field>

        <div v-if="!task.clientId">
          <v-text-field label="Adresa" v-model="task.address"> </v-text-field>
        </div>

        <v-textarea label="Note interventie" v-model="task.notes"> </v-textarea>

        <v-switch
          label="Culoare personalizata"
          v-model="needsCustomColor"
          class="mx-2"
        ></v-switch>

        <v-color-picker
          v-if="needsCustomColor"
          v-model="task.color"
          flat
        ></v-color-picker>

        <v-switch
          label="Finalizat"
          v-model="task.finished"
          class="mx-2"
        ></v-switch>

        <v-switch
          label="Trimite sms acum"
          v-model="task.sendNotification"
          class="mx-2"
        ></v-switch>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn
            v-if="task.id !== undefined"
            @click="deleteItem"
            color="red"
            class="mx-2"
          >
            Sterge
          </v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'task-form',
  props: ['task', 'onSubmit'],
  data() {
    return {
      search: null,
      valid: true,
      model: null,
      requiredRule: [(v) => !!v || 'Campul trebuie completat.'],
      needsCustomColor: false,
      timePickerProps: {
        format:'24hr'
      }
    };
  },
  created() {
    this.$store.dispatch('users/getUsers');
  },

  computed: {
    listUsers() {
      return this.$store.state.users.users;
    },

    listClients() {
      return this.$store.state.clients.clients;
    },
  },

  watch: {
    search(query) {
      this.$store.dispatch('clients/search', query);
    },

    needsCustomColor(value) {
      this.task.color = value ? '#000000' : null;
    },
  },

  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },

    deleteItem() {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('tasks/delete', this.$route.params.id);
        this.$router.push({ path: '/tasks' });
      }
    },

    changeStartDate(date) {
      const endAt = new Date(date);
      endAt.setHours(date.getHours() + 1);

      this.task.endAt = endAt;
    },
  },
};
</script>

<style>
</style>
